// Add your custom JS here.

// ===== Scroll to Top ====
(function($) {
  $(window).scroll(function() {
      if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
          $('#return-to-top').fadeIn(200);    // Fade in the arrow
      } else {
          $('#return-to-top').fadeOut(200);   // Else fade out the arrow
      }
  });
  $('#return-to-top').click(function() {      // When arrow is clicked
      $('body,html').animate({
          scrollTop : 0                       // Scroll to top of body
      }, 500);
  });
})(jQuery);


// Add your custom JS here.
(function ($) {
  function normalizeSlideHeights() {
    $('.carousel').each(function () {
      var items = $('.carousel-item', this);
      // reset the height
      items.css('min-height', 0);
      // set the height
      var maxHeight = Math.max.apply(null,
        items.map(function () {
          return $(this).outerHeight()
        }).get());
      items.css('min-height', maxHeight + 'px');
    })
  }

  $(window).on(
    'load resize orientationchange',
    normalizeSlideHeights);
})(jQuery);

(function ($) {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 20) {
      $('#wrapper-navbar').addClass("fixed-top-nc");
      $('#cat-head').addClass("vis");
    } else {
      $('#wrapper-navbar').removeClass("fixed-top-nc");
      $('#cat-head').removeClass("vis");
      $('#main-nav').removeClass("op-fx-mn");
    }
  });
  //effect smarthphone
  var lastScrollTop = 0;
  var body = document.body;
  window.addEventListener("scroll", function () {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var scrollTopCont = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > lastScrollTop) {
      $('#wrapper-navbar').removeClass("fixed-top-sm");
    }
    if (scrollTop < lastScrollTop) {
      $('#wrapper-navbar').addClass("fixed-top-sm");
      $('.site').addClass("pad-top-sm");
    }
    lastScrollTop = scrollTop;
  });

  document.querySelector('.op-fx-btn').addEventListener('click', function (event) {
    event.preventDefault();
    var target = document.querySelector('#main-nav');
    if (target.classList.contains('op-fx-mn')) {
      target.classList.remove('op-fx-mn');
    } else {
      target.classList.add('op-fx-mn');
    }
  });
})(jQuery);


(function ($) {
  $('.carousel-multiple-items').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $(".prev-btn").click(function () {
		$(".carousel-multiple-items").slick("slickPrev");
	});

	$(".next-btn").click(function () {
		$(".carousel-multiple-items").slick("slickNext");
	});
	$(".prev-btn").addClass("slick-disabled");
	$(".carousel-multiple-items").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn").addClass("slick-disabled");
		} else {
			$(".prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn").addClass("slick-disabled");
		} else {
			$(".next-btn").removeClass("slick-disabled");
		}
	});

})(jQuery);



(function ($) {
  // VARIABLES
  const timeline = document.querySelector(".timeline ol"),
    elH = document.querySelectorAll(".timeline li > div"),
    arrows = document.querySelectorAll(".timeline .arrows .arrow"),
    arrowPrev = document.querySelector(".timeline .arrows .arrow__prev"),
    arrowNext = document.querySelector(".timeline .arrows .arrow__next"),
    firstItem = document.querySelector(".timeline li:first-child"),
    lastItem = document.querySelector(".timeline li:last-child"),
    xScrolling = 280,
    disabledClass = "disabled";

  // START
  window.addEventListener("load", init);

  function init() {
    setEqualHeights(elH);
    animateTl(xScrolling, arrows, timeline);
    setSwipeFn(timeline, arrowPrev, arrowNext);
    setKeyboardFn(arrowPrev, arrowNext);
  }

  // SET EQUAL HEIGHTS
  function setEqualHeights(el) {
    let counter = 0;
    for (let i = 0; i < el.length; i++) {
      const singleHeight = el[i].offsetHeight;

      if (counter < singleHeight) {
        counter = singleHeight;
      }
    }

    for (let i = 0; i < el.length; i++) {
      el[i].style.height = `${counter}px`;
    }
  }

  // CHECK IF AN ELEMENT IS IN VIEWPORT
  // http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  // SET STATE OF PREV/NEXT ARROWS
  function setBtnState(el, flag = true) {
    if (flag) {
      el.classList.add(disabledClass);
    } else {
      if (el.classList.contains(disabledClass)) {
        el.classList.remove(disabledClass);
      }
      el.disabled = false;
    }
  }

  // ANIMATE TIMELINE
  function animateTl(scrolling, el, tl) {
    let counter = 0;
    for (let i = 0; i < el.length; i++) {
      el[i].addEventListener("click", function () {
        if (!arrowPrev.disabled) {
          arrowPrev.disabled = true;
        }
        if (!arrowNext.disabled) {
          arrowNext.disabled = true;
        }
        const sign = this.classList.contains("arrow__prev") ? "" : "-";
        if (counter === 0) {
          tl.style.transform = `translateX(-${scrolling}px)`;
        } else {
          const tlStyle = getComputedStyle(tl);
          // add more browser prefixes if needed here
          const tlTransform =
            tlStyle.getPropertyValue("-webkit-transform") ||
            tlStyle.getPropertyValue("transform");
          const values =
            parseInt(tlTransform.split(",")[4]) +
            parseInt(`${sign}${scrolling}`);
          tl.style.transform = `translateX(${values}px)`;
        }

        setTimeout(() => {
          isElementInViewport(firstItem)
            ? setBtnState(arrowPrev)
            : setBtnState(arrowPrev, false);
          isElementInViewport(lastItem)
            ? setBtnState(arrowNext)
            : setBtnState(arrowNext, false);
        }, 1100);

        counter++;
      });
    }
  }

  // ADD SWIPE SUPPORT FOR TOUCH DEVICES
  function setSwipeFn(tl, prev, next) {
    const hammer = new Hammer(tl);
    hammer.on("swipeleft", () => next.click());
    hammer.on("swiperight", () => prev.click());
  }

  // ADD BASIC KEYBOARD FUNCTIONALITY
  function setKeyboardFn(prev, next) {
    document.addEventListener("keydown", (e) => {
      if (e.which === 37 || e.which === 39) {
        const timelineOfTop = timeline.offsetTop;
        const y = window.pageYOffset;
        if (timelineOfTop !== y) {
          window.scrollTo(0, timelineOfTop);
        }
        if (e.which === 37) {
          prev.click();
        } else if (e.which === 39) {
          next.click();
        }
      }
    });
  }

})(jQuery);

// GSAP ScrollToPlugin to auto scroll left/right (scroll sulla galleria all'hover)
(function ($) {
	$(window).on("load", function() {

  var $landingWrapper = $(".landing-wrapper"),
      $landingInnerContent = $(".landing-inner-content");

  // set initial container to half of .landing-inner-content width
  // TweenMax.set($landingWrapper, {scrollTo: {x: $landingInnerContent.width()/4}, ease: Power2.easeOut});

  // scroll left and right
  $landingInnerContent.on("mousemove touchmove", function(e) {
    if (window.innerWidth >= 992) {
      if (e.clientX > $landingWrapper.width() / 2) {
        TweenMax.to($landingWrapper, 2, {
          scrollTo: {
            x: "+=80"
          },
          ease: Power2.easeOut
        });
      } else {
        TweenMax.to($landingWrapper, 2, {
          scrollTo: {
            x: "-=80"
          },
          ease: Power2.easeOut
        });
      }
    } else {
      if (e.clientX > $landingWrapper.width() / 2) {
        TweenMax.to($landingWrapper, 2, {
          scrollTo: {
            x: "+=140"
          },
          ease: Power2.easeOut
        });
      } else {
        TweenMax.to($landingWrapper, 2, {
          scrollTo: {
            x: "-=140"
          },
          ease: Power2.easeOut
        });
      }
    }
  });

});
})(jQuery);



// show popup on hover in Timeline
(function ($) {
  $(".tiptext").mouseover(function() {
    $(this).children(".popup-hover").show();
}).mouseout(function() {
    $(this).children(".popup-hover").hide();
});

})(jQuery);
